function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useEffect, useState } from 'react';
import IntegrationCard from "../IntegrationCard/IntegrationCard";
import ZapierLogo from "./zapier-logo.svg";
import { Button, ConfirmationModal, Typography } from 'seagull';
import { useOverlayContext } from 'seagull';
import styles from "./ZapierCard.module.scss";
import { useEventReporter, useStoreActions } from "../../../contexts";
import { NewTab } from 'seagull/icons';
import { openInNewTabProps } from "../../../constants";
import { CopyToClipboard } from "../../../components/CopyToClipboard/CopyToClipboard";
export default function ZapierCard() {
  const overlayContext = useOverlayContext();
  const {
    logBI
  } = useStoreActions();
  const {
    reportToAppcues,
    reportToGtm,
    reportToHeap,
    reportToHubspot
  } = useEventReporter();
  const openIntegrateWithZapierModal = () => {
    logBI(12050);
    reportToAppcues('button-click', 'zapier-vendor-clicked-connect');
    reportToGtm('button-click', 'zapier-vendor-clicked-connect');
    reportToHeap('integrations', 'click', 'zapier-connect');
    reportToHubspot('vendor_clicked_connect_to_zapier');
    overlayContext.showModal({
      closeOnEscapeKey: true,
      closeOnClickOutside: true,
      content: _ref => {
        let {
          dismissModal
        } = _ref;
        return /*#__PURE__*/React.createElement(IntegrateWithZapierModal, {
          dismissModal: dismissModal
        });
      }
    });
  };
  return /*#__PURE__*/React.createElement(IntegrationCard, {
    "data-testid": "zapier-card",
    icon: /*#__PURE__*/React.createElement(ZapierLogo, null),
    title: "Zapier",
    subTitle: "Integrate Anchor with hundreds of other apps to automate your work.",
    mainAction: /*#__PURE__*/React.createElement(IntegrationCard.MainActionButton, {
      onClick: openIntegrateWithZapierModal,
      "data-testid": "zapier-card-connect"
    }, "Connect")
  });
}
const IntegrateWithZapierModal = _ref2 => {
  let {
    dismissModal
  } = _ref2;
  const {
    api
  } = useStoreActions();
  const [apiKey, setApiKey] = useState('');
  const [helperText, setHelperText] = useState('');
  const {
    logBI
  } = useStoreActions();
  const {
    reportToAppcues,
    reportToGtm,
    reportToHeap,
    reportToHubspot
  } = useEventReporter();
  useEffect(() => {
    api.zapier.getApiKey().then(setApiKey).catch(() => setHelperText('API key not found. Please try again later.'));
  }, []);
  return /*#__PURE__*/React.createElement(ConfirmationModal, {
    title: "Integrate with Zapier",
    width: "760px",
    content: /*#__PURE__*/React.createElement("div", {
      className: styles.modalContainer
    }, /*#__PURE__*/React.createElement(Typography, null, "To integrate with Zapier, follow the next steps: "), /*#__PURE__*/React.createElement(Typography, null, "1. Copy the API key below"), /*#__PURE__*/React.createElement("div", {
      className: styles.copyApiKeyContainer
    }, /*#__PURE__*/React.createElement(CopyToClipboard, {
      "data-testid": "api-key",
      value: apiKey,
      helperText: helperText,
      error: !!helperText,
      onClick: () => {
        logBI(12051);
        reportToAppcues('button-click', 'zapier-vendor-copied-api-key-to-clipboard');
        reportToGtm('button-click', 'zapier-vendor-copied-api-key-to-clipboard');
        reportToHeap('integrations', 'click', 'zapier-copy-api-key');
        reportToHubspot('vendor_copied_api_key_to_clipboard');
      }
    })), /*#__PURE__*/React.createElement(Typography, null, "2. Login to your Zapier account, create a zap with Anchor and paste the API key"), /*#__PURE__*/React.createElement(Button, _extends({
      skin: "primaryOutline",
      "data-testid": "go-to-zapier",
      as: "a",
      suffixIcon: /*#__PURE__*/React.createElement(NewTab, null),
      href: "https://zapier.com/app/connections"
    }, openInNewTabProps, {
      className: styles.goToZapierContainer
    }), "Go to Zapier")),
    primaryButtonLabel: "Close",
    onPrimaryButtonClick: dismissModal,
    onCloseButtonClick: dismissModal,
    "data-testid": "integrate-with-zapier-modal"
  });
};